<p-card [header]="title" styleClass="chart-card" class="mt-4" [style]="{'width': '720px'}">
    <div class="chart-container">
      <canvas #chartCanvas [style]="{'max-height': '480px'}"></canvas>
    </div>
  </p-card>
  